var m = require('mithril');
var layout = require('../layout/layout');
var bindingPage = require('./bindingPage');

var routes = {
  '/binding': {
    view: function () {
      return m(layout, m(bindingPage));
    }
  }
};

module.exports = routes;
